import { render, staticRenderFns } from "./PropertyTooltipContent.global.vue?vue&type=template&id=4bc61e88&scoped=true&lang=pug&"
import script from "./PropertyTooltipContent.global.vue?vue&type=script&lang=ts&"
export * from "./PropertyTooltipContent.global.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyTooltipContent.global.vue?vue&type=style&index=0&id=4bc61e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc61e88",
  null
  
)

export default component.exports